import { useState, useEffect } from 'react';

export const useMicrophones = (isElectron = false) => {
  const [microphones, setMicrophones] = useState([]);
  const [selectedMicId, setSelectedMicId] = useState('');
  const [captureSystemAudio, setCaptureSystemAudio] = useState(isElectron);

  useEffect(() => {
    const fetchMicrophones = async () => {
      try {
        // First get permission
        await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
        
        // Then enumerate devices
        const devices = await navigator.mediaDevices.enumerateDevices();
        const mics = devices.filter((d) => d.kind === 'audioinput');
        
        // Debug logging
        console.log('All microphones found:', mics.map(m => ({
          label: m.label,
          deviceId: m.deviceId,
          groupId: m.groupId
        })));
        
        // Remove duplicates based on label
        const seenLabels = new Map();
        const uniqueMics = [];
        
        for (const mic of mics) {
          // Skip devices without labels
          if (!mic.label) continue;
          
          // Create a normalized label for comparison
          const normalizedLabel = mic.label.trim();
          
          // Check if we've seen this exact label before
          if (!seenLabels.has(normalizedLabel)) {
            seenLabels.set(normalizedLabel, mic.deviceId);
            uniqueMics.push(mic);
          }
        }
        
        // Debug logging
        console.log('Unique microphones:', uniqueMics.map(m => m.label));
        
        // If no labeled devices found, fall back to first device only
        const finalMics = uniqueMics.length > 0 ? uniqueMics : mics.slice(0, 1);
        
        setMicrophones(finalMics);
        
        // Only set selectedMicId if it's not already set
        if (finalMics.length > 0 && !selectedMicId) {
          setSelectedMicId(finalMics[0].deviceId);
        }
      } catch (err) {
        console.error('Kunde inte hämta enheter:', err);
      }
    };

    fetchMicrophones();
    
    // Listen for device changes
    const handleDeviceChange = () => {
      fetchMicrophones();
    };
    
    navigator.mediaDevices.addEventListener('devicechange', handleDeviceChange);
    
    return () => {
      navigator.mediaDevices.removeEventListener('devicechange', handleDeviceChange);
    };
  }, []); // Remove selectedMicId from dependencies to avoid re-fetching

  return {
    microphones,
    selectedMicId,
    setSelectedMicId,
    captureSystemAudio,
    setCaptureSystemAudio
  };
};